import reducer from "./reducers";

export { default as UI } from "./containers";

export default reducer;
